import styled from 'styled-components';

export const Label = styled.span`
  font-weight: bold;
  color: #828282;
`;

export const Detail = styled.span`
  display: block;
  text-align: justify;
  color: #828282;
`;
